export default __webpack_public_path__ + "images/379cdbc65fdc8c15176992c9c6bd741f.svg";